import { render } from "./DashboardProfilesSearchAndListView.vue?vue&type=template&id=ab2d3a68&ts=true"
import script from "./DashboardProfilesSearchAndListView.vue?vue&type=script&lang=ts"
export * from "./DashboardProfilesSearchAndListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__